export default __webpack_public_path__ + "static/media/Group 11286.0597fff0.png";